import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SilentSsoLoginService {
  private readonly USER_EMAIL_KEY = 'silent_sso_login_user_email';
  private readonly SILENT_LOGIN_PARAM_NAME = 'silentLogin';

  private readonly ACCOUNT_ID_KEY = 'account_id';
  private readonly ACCOUNT_ID_PARAM_NAME = 'accountId';

  get userEmail() {
    return localStorage.getItem(this.USER_EMAIL_KEY);
  }

  set userEmail(userEmail: string) {
    localStorage.setItem(this.USER_EMAIL_KEY, userEmail);
  }

  get accountId() {
    return localStorage.getItem(this.ACCOUNT_ID_KEY);
  }

  set accountId(accountId: string) {
    localStorage.setItem(this.ACCOUNT_ID_KEY, accountId);
  }

  clear() {
    localStorage.removeItem(this.USER_EMAIL_KEY);
    localStorage.removeItem(this.ACCOUNT_ID_KEY);
  }

  setUserEmailFromQueryString() {
    const userEmail = this.getParamByName(this.SILENT_LOGIN_PARAM_NAME);
    if (!userEmail) {
      return;
    }
    this.userEmail = userEmail;
  }

  setAccountIdFromQueryString() {
    const accountId = this.getParamByName(this.ACCOUNT_ID_PARAM_NAME);
    if (!accountId) {
      return;
    }
    this.accountId = accountId;
  }

  private getParamByName(name: string): string | undefined {
    if (!window.URLSearchParams) {
      return undefined;
    }
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
}
